// import data
import atomToolsData from "../../data/content/about/atom/atomTools.json";
import ardiToolsData from "../../data/content/about/ardi/ardiTools.json";
import applicationAreasData from "../../data/content/robotics/applicationAreas.json";
import { DataStructure } from '../../types';
// import components
import { MainFrame, SpacingFrame, HorizontalScrollArrowsFrame } from "../display/Frame";
import { ToolCard, ToolCard2, ToolCardNoLink } from "../display/Cards";
import { TitleSubtitle } from "../display/TextFormat";
import { MoreButton } from "../tools/Buttons";
// import context
import { useLang } from "../Context";
// import image
import dotsImage from "../../image/drugomics/3dots.svg";

const typedAtomTools : DataStructure = atomToolsData;
const typedArdiTools : DataStructure = ardiToolsData;
const typedApplicationAreas : DataStructure = applicationAreasData;

interface ToolsOverviewProps {
    isScroll?: boolean;
    isMoreButton?: boolean; 
    smallerPadding?: boolean; 
};
export function AtomToolsOverview({ isScroll, isMoreButton, smallerPadding } : ToolsOverviewProps) {
    const { lang } = useLang();

    // tools
    let toolCards = Object.keys(typedAtomTools["content"]).map((i) => {
        let data = typedAtomTools["content"][i];
        return (
            <ToolCard2 data={data} isBulletList width={336} height={164} imagePath="image/icons/"/>
        )
    });

    let layout = isScroll
                ?   <>
                        <HorizontalScrollArrowsFrame>
                            { toolCards }
                        </HorizontalScrollArrowsFrame>
                        <MoreButton label="View All Tools" link="/about/technologies/atom" darkMode />
                    </>
                :   
                    <>
                        <div className="lg:grid lg:grid-cols-3 sm:flex sm:flex-col gap-5 mx-auto">
                            { toolCards }
                        </div>

                        {isMoreButton && (
                            <MoreButton label="View All Tools" link="/about/technologies/atom" darkMode />
                        )}
                    </>

    return (
        <MainFrame smallerPadding={smallerPadding}>
            <SpacingFrame spacing={40}>
                <div className="flex flex-col-reverse lg:flex-row items-start gap-8">
                <div className="w-full lg:w-1/3">
                <img src={dotsImage} alt="" />
                </div>
                
                <div className="w-full lg:w-2/3">
                    <TitleSubtitle 
                    title={typedAtomTools["title"][lang]}
                    subtitle={typedAtomTools["subtitle"][lang]}
                    right
                    spacing={40}
                    />
                </div>
                </div>
                { layout }
            </SpacingFrame>
        </MainFrame>
    )
};


export function AtomToolsOverviewOld({ isScroll } : ToolsOverviewProps) {
    const { lang } = useLang();

    // tools
    let toolCards = Object.keys(typedAtomTools["content"]).map((i) => {
        let data = typedAtomTools["content"][i];
        return (
            <ToolCard data={data} isBulletList width={240} height={244} />
        )
    });

    let layout = isScroll
                ?   <>
                        <HorizontalScrollArrowsFrame>
                            { toolCards }
                        </HorizontalScrollArrowsFrame>
                        <MoreButton label="View All Tools" link="/about/technologies/atom" darkMode />
                    </>
                :   <div className="lg:grid lg:grid-cols-4 sm:flex sm:flex-col gap-5 mx-auto">
                        { toolCards }
                    </div>

    return (
        <MainFrame>
            <SpacingFrame spacing={40}>
                <TitleSubtitle 
                title={typedAtomTools["title"][lang]}
                subtitle={typedAtomTools["subtitle"][lang]}
                left
                spacing={40}
                />
                { layout }
            </SpacingFrame>
        </MainFrame>
    )
};

export function ArdiToolsOverview({ isScroll } : ToolsOverviewProps) {
    const { lang } = useLang();

    // tools
    let toolCards = Object.keys(typedArdiTools["content"]).map((i) => {
        let data = typedArdiTools["content"][i];
        return (
            <ToolCard data={data} isBulletList width={240} height={244} />
        )
    });

    let layout = isScroll
                ?   <>
                        <HorizontalScrollArrowsFrame>
                            { toolCards }
                        </HorizontalScrollArrowsFrame>
                        <MoreButton label="View All Tools" link="/about/technologies/ardi" darkMode />
                    </>
                :   <div className="lg:grid lg:grid-cols-4 sm:flex sm:flex-col gap-5 mx-auto">
                        { toolCards }
                    </div>

    return (
        <MainFrame style={{ backgroundColor: "#A2DADB" }}>
            <SpacingFrame spacing={40}>
                <TitleSubtitle title={ typedArdiTools["title"][lang] } />
                <p>{ typedArdiTools["subtitle"][lang] }</p>
                { layout }
            </SpacingFrame>
        </MainFrame>
    )
};

export function ApplicationAreasOverview({ smallerPadding } : ToolsOverviewProps) {
    const { lang } = useLang();

    // Create area cards without links
    let areaCards = Object.keys(typedApplicationAreas["content"]).map((i) => {
        let data = typedApplicationAreas["content"][i];
        return (
            <ToolCardNoLink key={i} data={data} isBulletList={false} width={240} height={244} />
        )
    });

    return (
        <MainFrame style={{ backgroundColor: "#A2DADB" }} smallerPadding={smallerPadding}>
            <SpacingFrame spacing={40}>
                <TitleSubtitle title={ typedApplicationAreas["title"][lang] } />
                <p>{ typedApplicationAreas["subtitle"][lang] }</p>
                <div className="lg:grid lg:grid-cols-4 sm:flex sm:flex-col gap-5 mx-auto">
                    { areaCards }
                </div>
            </SpacingFrame>
        </MainFrame>
    )
};